<template>
    <CRow>
        <CCol col="12" lg="12">
            <CCard>
                <CCardBody>
                    <h3>
                        {{ $t('premium.title') }}
                    </h3>
                    <br>
                    <CRow>
                        <CCol col="12" lg="12">
                            <div v-html="configuration"/>
                        </CCol>
                   </CRow>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import axios from 'axios'
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
    name: 'Premium',
    data() {
        return {
            updateIcon: cilSync,
            addIcon: cilPlus,
            backIcon: cilArrowLeft,
            configuration: null,
        }
    },
    async mounted() {
        let self = this;
        const token = localStorage.getItem('token', null);

        axios.post(`configuration`, { version: 0 }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            })
            .then(response => {
                this.configuration = response.data.configuration.premium
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });
    }
}
</script>
